var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "language-manager col-12" }, [
    _c("div", [
      _c("h3", [_vm._v("Options")]),
      _vm._v(" "),
      _c("p", [_vm._v("Display edit options for:")]),
      _vm._v(" "),
      _c("div", { staticClass: "form-check" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.display_english,
              expression: "display_english",
            },
          ],
          staticClass: "form-check-input",
          attrs: { type: "checkbox", id: "check-english", value: "" },
          domProps: {
            checked: _vm.display_english,
            checked: Array.isArray(_vm.display_english)
              ? _vm._i(_vm.display_english, "") > -1
              : _vm.display_english,
          },
          on: {
            click: _vm.toggleEnglish,
            change: function ($event) {
              var $$a = _vm.display_english,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = "",
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.display_english = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.display_english = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.display_english = $$c
              }
            },
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          { staticClass: "form-check-label", attrs: { for: "check-english" } },
          [_vm._v("\n                    English\n                ")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-check" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.display_chinese,
              expression: "display_chinese",
            },
          ],
          staticClass: "form-check-input",
          attrs: { type: "checkbox", id: "check-chinese", value: "" },
          domProps: {
            checked: _vm.display_chinese,
            checked: Array.isArray(_vm.display_chinese)
              ? _vm._i(_vm.display_chinese, "") > -1
              : _vm.display_chinese,
          },
          on: {
            click: _vm.toggleChinese,
            change: function ($event) {
              var $$a = _vm.display_chinese,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = "",
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.display_chinese = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.display_chinese = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.display_chinese = $$c
              }
            },
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          { staticClass: "form-check-label", attrs: { for: "check-chinese" } },
          [_vm._v("\n                    Chinese\n                ")]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", [
      _c("h3", [_vm._v("Search")]),
      _vm._v(" "),
      _c("div", { staticClass: "input-group mb-3" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.search_string,
              expression: "search_string",
            },
          ],
          staticClass: "form-control",
          attrs: {
            type: "text",
            placeholder: "Search for the key or the displayed text",
            "aria-label": "Search for the key or the displayed text",
            "aria-describedby": "search-button",
          },
          domProps: { value: _vm.search_string },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.search_string = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-outline-primary",
            attrs: { type: "button", id: "search-button" },
            on: {
              click: function ($event) {
                return _vm.searchLangItems()
              },
            },
          },
          [_vm._v("Search")]
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("Displaying " + _vm._s(_vm.pagination_meta.total) + " items"),
      ]),
    ]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "mt-3" }, [
      _c("h3", [_vm._v("Language Editor")]),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid" }, [
        _c("table", { staticClass: "table table-hover" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "tbody",
            [
              _vm._l(_vm.displayed_lang_items, function (lang_item) {
                return _c("tr", [
                  _c("th", [_vm._v(_vm._s(lang_item.key))]),
                  _vm._v(" "),
                  _c("td", [
                    _vm.display_english
                      ? _c("div", [
                          _c("small", [_vm._v("English")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "input-group mb-1" }, [
                            _c("input", {
                              staticClass: "form-control",
                              attrs: {
                                id: "en-" + lang_item.key,
                                type: "text",
                                placeholder: "empty",
                                "aria-label": "Enter your new language value",
                                "aria-describedby": "search-button",
                              },
                              domProps: { value: lang_item.en },
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-outline-primary",
                                attrs: {
                                  type: "button",
                                  id: "save-button-" + "en-" + lang_item.key,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.saveLangItem(
                                      "en-" + lang_item.key
                                    )
                                  },
                                },
                              },
                              [_vm._v("Save")]
                            ),
                            _vm._v(" "),
                            lang_item.is_override
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-outline-danger",
                                    attrs: {
                                      type: "button",
                                      id:
                                        "reset-button-" + "en-" + lang_item.key,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.resetLangItem(
                                          "en-" + lang_item.key
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Reset")]
                                )
                              : _vm._e(),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.display_chinese
                      ? _c("div", [
                          _c("small", [_vm._v("Chinese")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "input-group mb-1" }, [
                            _c("input", {
                              staticClass: "form-control",
                              attrs: {
                                id: "cn-" + lang_item.key,
                                type: "text",
                                placeholder: "empty",
                                "aria-label": "Enter your new language value",
                                "aria-describedby": "search-button",
                              },
                              domProps: { value: lang_item.cn },
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-outline-primary",
                                attrs: {
                                  type: "button",
                                  id: "save-button-" + "cn-" + lang_item.key,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.saveLangItem(
                                      "cn-" + lang_item.key
                                    )
                                  },
                                },
                              },
                              [_vm._v("Save")]
                            ),
                            _vm._v(" "),
                            lang_item.is_override
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-outline-danger",
                                    attrs: {
                                      type: "button",
                                      id:
                                        "reset-button-" + "cn-" + lang_item.key,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.resetLangItem(
                                          "cn-" + lang_item.key
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Reset")]
                                )
                              : _vm._e(),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ])
              }),
              _vm._v(" "),
              _vm.displayed_lang_items.length === 0
                ? _c("tr", [
                    _c("th", [_vm._v("-- No Language items --")]),
                    _vm._v(" "),
                    _c("td"),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("nav", { attrs: { "aria-label": "Next Page" } }, [
        _c(
          "ul",
          { staticClass: "pagination" },
          _vm._l(_vm.pagination_meta.links, function (link) {
            return _c(
              "li",
              {
                staticClass: "page-item",
                class: [
                  link.active ? "active" : "",
                  link.url ? "" : "disabled",
                ],
                on: {
                  click: function ($event) {
                    return _vm.paginationLinkClick(link.url)
                  },
                },
              },
              [
                _c("a", { staticClass: "page-link", attrs: { href: "#" } }, [
                  _c("span", { domProps: { innerHTML: _vm._s(link.label) } }),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "col-sm-3" }, [_vm._v("Key")]),
        _vm._v(" "),
        _c("th", { staticClass: "col-sm-9" }, [_vm._v("Value")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }